<template>
  <next-button v-if="!completed" @click="openModal" text="Add Self-Certification Details" />
  <SelfCertificationDetailsFormModal
    v-if="modalActive"
    :stip="stip"
    @success="emit('success', $event)"
  />
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import NextButton from "@/components/shared/NextButton.vue";
import type { Stipulation } from "@/models/opal";
import SelfCertificationDetailsFormModal from "@/components/modals/SelfCertificationDetailsFormModal.vue";
import { StipulationStatusIds } from "@/config/constants";

const store = useStore();

interface Props {
  stip: Stipulation;
}

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
  (e: "success", updatedStip: Stipulation): void;
}>();

const modalActive = computed<boolean>(() => store.state.modal.selfCertificationDetailsModalActive);

const completed = computed<boolean>(
  () =>
    props.stip.stipulationStatusId === StipulationStatusIds.COMPLETED ||
    props.stip.stipulationStatusId === StipulationStatusIds.CU_OVERRIDE,
);

function openModal() {
  store.dispatch("modal/openSelfCertificationDetailsModal");
}
</script>
<style>
.self-certification-modal .form-field label {
  color: #000;
  font-family: var(--header-font);
  font-size: 14px;
  font-style: normal;
  font-weight: var(--font-weight-normal);
  line-height: 16px; /* 114.286% */
}

.self-certification-modal .modal-container {
  border-radius: 6px;
}

.self-certification-modal .self-certification-details-form .form-field select {
  margin-right: 0;
}

.self-certification-modal:is(.confirm) .modal-body {
  min-height: fit-content;
}

.self-certification-modal:is(.confirm) .modal-footer {
  display: none;
  opacity: 0;
}

.self-certification-modal:is(.confirm) .modal-header .modal-title {
  height: 35px;
  padding: 0;
}

@media (min-width: 992px) {
  .self-certification-modal:is(.confirm) .modal-container {
    width: 65%;
    max-width: 640px;
  }

  .self-certification-modal:not(.confirm) .modal-container {
    max-width: 85%;
  }
}

@media (max-width: 992px) {
  .self-certification-modal .modal-container,
  .self-certification-modal:is(.confirm) {
    max-width: none;
  }
}
</style>
